

export default function OurProducts() {

 
    const productName = [
        "Spice Blends & Powders",
        "Dried Chiles & More",
        " All Categories of  Seeds",
        "Pods, Berries & Bark Spices",
        "Pure and Trusted Turmeric Powder",
        "Other Products"
    ]

    const imageUrl = [
       
"https://images.pexels.com/photos/7160696/pexels-photo-7160696.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
"https://images.pexels.com/photos/112780/pexels-photo-112780.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
"https://images.pexels.com/photos/3040873/pexels-photo-3040873.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
"https://images.pexels.com/photos/5988689/pexels-photo-5988689.jpeg?auto=compress&cs=tinysrgb&w=600",
"https://images.pexels.com/photos/4198418/pexels-photo-4198418.jpeg?auto=compress&cs=tinysrgb&w=600",
"https://images.pexels.com/photos/5475172/pexels-photo-5475172.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    ]


  return (
    <div className='mt-32 bg-[#f3f8f3] w-full h-full pb-24'>
      
      <div className='bg-transparent'>

<div className='headings bg-transparent pt-24 '>
<img src="./Images/Home/services-pattern.png" className="bg-transparent inline-block ml-24 " alt="imag"/>
<p className='text-center text-2xl bg-transparent text-green-500 uppercase'>Our Products </p>
<h3 className='bg-transparent text-6xl text-center md:px-[25%] pt-4 text-black'> We Provide Professional Energy Solutions </h3>



</div>

<div className="flex">

<div className=' flex justify-around items-center md:mx-24 flex-wrap bg-transparent'>

{
    productName.map((product,index)=>(

        <div className='border-b-4 w-[350px]  md:w-[400px]  rounded-t-2xl bg-white rounded-t-4 shadow-2xl relative my-12 rounded-b-xl md:px-12 px-2 py-8 h-[200px]  hover:border-b-green-500 group transition-colors duration-300 cursor-pointer'>


        <img src={imageUrl[index]}   alt='image_name'
 className='float-right w-24 rounded-lg -mt-6 shadow-xl group-hover:scale-95 transition-transform duration-200'
 />


<p className='text-2xl w-full bg-transparent '> {product}  </p>
<button className='mt-12 absolute bottom-0 mb-6 hover: rounded-lg px-3 py-2 group-hover:bg-green-500  hover:text-white transition-colors duration-200 '>See other </button>

        </div>

    ))
}

</div>

</div>

      </div>

    </div>
  )
}
